import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import * as Sentry from '@sentry/react';
import { config } from './utils';
import { getCurrentUserRole } from './providers/Auth';

// we don't want this when running cypress in CI
if (config.ENV === 'development' && !config.IS_CI) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

if (config.SENTRY_DSN && config.SENTRY_ENV && !config.IS_CI && !config.IS_SERVED_FROM_MOCK_SERVER) {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    release: config.APP_VERSION,
    // The 'SENTRY_ENV' could be either of the following:
    // 'local' - for error tracking on localhost (mainly for debugging if needed)
    // 'development' - for error tracking on *.askporter.dev
    // 'staging' - for error tracking on *.askporter.qa
    // 'production' - for error tracking on *.askporter.io
    environment: config.SENTRY_ENV,
    beforeSend: (event, hint) => {
      // if the error is coming from an authenticated page then
      // add the user's role to the tags before sending the error
      if (event && getCurrentUserRole) {
        const role = getCurrentUserRole();
        if (role) {
          if (event.tags) {
            event.tags = { ...event.tags, role };
          } else {
            event.tags = { role };
          }
        }
      }
      // print the error to the console when in development
      // as the error can go unnoticed sometimes
      if (config.ENV === 'development') {
        const error = hint?.originalException;
        if (error) {
          console.error(error);
        }
      }
      return event;
    },
    beforeBreadcrumb: (breadcrumb, hint) => {
      if (breadcrumb.category === 'xhr') {
        let amznTraceId;

        try {
          if (hint?.xhr.getAllResponseHeaders().indexOf('x-amzn-trace-id') >= 0) {
            amznTraceId = hint?.xhr.getResponseHeader('x-amzn-trace-id');
          }

          // if a trace id header exists then add it to the breadcrumb data so it shows up in sentry
          if (amznTraceId) breadcrumb.data['x-amzn-trace-id'] = amznTraceId;
        } catch (e) {
          // intentionally avoiding logging errors here
        }
      }

      return breadcrumb;
    },
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
